module.exports = __webpack_public_path__ + "static/media/heat_warning.6e8481c6.svg";